var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskFileDonwloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5026 11.333L4.96094 7.79134L5.9526 6.76426L7.79427 8.60592V2.83301H9.21094V8.60592L11.0526 6.76426L12.0443 7.79134L8.5026 11.333ZM4.2526 14.1663C3.86302 14.1663 3.52963 14.0277 3.25244 13.7506C2.97524 13.4734 2.83641 13.1397 2.83594 12.7497V10.6247H4.2526V12.7497H12.7526V10.6247H14.1693V12.7497C14.1693 13.1393 14.0307 13.4729 13.7535 13.7506C13.4763 14.0282 13.1427 14.1668 12.7526 14.1663H4.2526Z",
    fill: "#4D4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskFileDonwloadIcon);
export default __webpack_public_path__ + "static/media/Task_File__Donwload_Icon.9219d0fe12a660e6aaa392c1ced0eb65.svg";
export { ForwardRef as ReactComponent };